// Human titles for catalog keys POS already shows (message types, product families,
// resource types, periods). Hosts translate these with _(); tools must not print the keys.

export const CATALOG_VALUE_LABELS: Record<string, string> = {
  // messages.list type
  orderConfirmation: 'Order confirmation',
  openOrderConfirmation: 'Open order confirmation',
  paymentConfirmation: 'Payment confirmation',
  billingConfirmation: 'Billing confirmation',
  processConfirmation: 'Process confirmation',
  orderCancellation: 'Order cancellation',
  orderRequestReceived: 'Order request received',
  orderRequestNotification: 'Order request notification',
  afterSales: 'After-sales letter',
  paymentLink: 'Payment link',
  confirmationLink: 'Confirmation link',
  confirmationlink: 'Confirmation link',
  finalPayment: 'Final payment notification',
  finalPaymentLate: 'Final payment late notification',
  subscriptionStart: 'Subscription started',
  subscriptionCancel: 'Subscription cancelled',
  subscriptionEnd: 'Subscription ended',
  subscriptionPaymentFailed: 'Subscription payment overdue',
  subscriptionRenewal: 'Subscription renewal payment',
  subscriptionChargeFailed: 'Subscription automatic payment failed',
  deliveryTerms: 'Order and cancellation terms',
  privacyPolicy: 'Privacy policy',
  accessibilityStatement: 'Accessibility statement',
  orderCompletion: 'Order completion page',
  checkinPage: 'Check in page',
  moreDescription: 'Additional info description',
  termsDescription: 'Terms description',
  marketingDescription: 'Marketing Consent description',

  // products.list type
  sellable: 'Sellable',
  reservable: 'Reservable',
  content: 'Content',
  ticket: 'Ticket',
  valuecard: 'Value card',
  archived: 'Archived',

  // resources.list displayedtype
  buyable: 'Buyable',
  openinghours: 'Opening hours',
  orphaned: 'Orphaned',
  resourcepool: 'Resource pool',
  generic: 'Generic',
  accommodation: 'Accommodation',
  room: 'Room',
  cottage: 'Cottage',
  villa: 'Villa',
  meetingroom: 'Meeting room',
  space: 'Space',
  theater: 'Theater',
  guide: 'Guide',
  vehicle: 'Vehicle',
  bicycle: 'Bicycle',
  motorcycle: 'Motorcycle',
  car: 'Car',
  bus: 'Bus',
  boat: 'Boat',
  plane: 'Plane',
  rentalgear: 'Rental gear',
  rentalequipment: 'Rental equipment',

  // tags.list / tags.create category
  product: 'Product',
  order: 'Order',
  admin: 'Admin',
  customer: 'Customer',
  resource: 'Resource',

  // discounts
  percent: 'Percent',
  amount: 'Amount',

  // issues
  resolved: 'Resolved',

  // orders / bills display filters
  unpaid: 'Unpaid',
  paid: 'Paid',
  notpaid: 'Not paid',
  refunded: 'Refunded',
  notprocessed: 'Not processed',
  processed: 'Processed',
  paidnotprocessed: 'Paid, not processed',
  confirmed: 'Confirmed',
  grouped: 'Grouped',
  withmore: 'With extras',
  paymentplans: 'Payment plans',
  refunds: 'Refunds',

  // date presets (also daterange options)
  today: 'Today',
  yesterday: 'Yesterday',
  lastweek: 'Last week',
  lastmonth: 'Last month',
  lastyear: 'Last year',
  thisweek: 'This week',
  thismonth: 'This month',
  thisyear: 'This year',
  overview: 'Overview',
  startingtoday: 'Starting today',
  startingtomorrow: 'Starting tomorrow',
  startingthisweek: 'Starting this week',
  startingthismonth: 'Starting this month',
  starting: 'All upcoming',
  endingtoday: 'Ending today',
  endingtomorrow: 'Ending tomorrow',
  endingthisweek: 'Ending this week',
  endingthismonth: 'Ending this month',
  all: 'All',
  custom: 'Select exact date range',

  // schedule / agenda buckets
  reservation: 'Reservation',
  availability: 'Availability',

  // CMS leftover types (content.list / content.create)
  BreadcrumbNavi: 'Breadcrumb',
  ContentImage: 'Image',
  FooterNavi: 'Footer navigation',
  Iframe: 'Iframe',
  Navi: 'Navigation',
  RichText: 'Rich text',
  Search: 'Search',
  Search2: 'Search',
  Search2Result: 'Search results',
  TopNavi: 'Top navigation'
}

export const CONTENT_TYPES = [
  'RichText', 'Search2', 'Search2Result', 'Search',
  'Navi', 'TopNavi', 'FooterNavi', 'BreadcrumbNavi',
  'ContentImage', 'Iframe'
] as const

export const MESSAGE_TYPES = [
  'orderConfirmation', 'openOrderConfirmation', 'paymentConfirmation', 'billingConfirmation',
  'processConfirmation', 'orderCancellation', 'orderRequestReceived', 'orderRequestNotification',
  'afterSales', 'paymentLink', 'confirmationLink', 'finalPayment', 'finalPaymentLate',
  'subscriptionStart', 'subscriptionCancel', 'subscriptionEnd', 'subscriptionPaymentFailed',
  'subscriptionRenewal', 'subscriptionChargeFailed', 'deliveryTerms', 'privacyPolicy',
  'accessibilityStatement', 'orderCompletion', 'checkinPage', 'moreDescription',
  'termsDescription', 'marketingDescription'
] as const

/** English title for a catalog key, or undefined when the value is ordinary data. */
export function catalogValueLabel (value: unknown, labels?: Record<string, string> | null): string | undefined {
  if (typeof value !== 'string' && typeof value !== 'number') return undefined
  const key = String(value)
  if (!key || key === '0' || key === '1') return undefined
  const map = labels && Object.keys(labels).length ? labels : CATALOG_VALUE_LABELS
  return map[key]
}
